<template lang="html">
<div class="v-scope-home-comunicacion-el">
<article class="comunicacion-el" :style="ownstyle.comunicacion">
    <h3 class="fecha" v-html="data.fechaDesde"></h3>
    <h2 class="titulo" v-html="data.descripcion"></h2>
    <arrow-link class="arrow-link" :text="'Ver más'" :to="data.enlace" :external="true" :blank="true"
      v-if="!!data.enlace"></arrow-link>
  </article>
</div>
</template>

<script lang="js">

import arrowLink from '@/components/parts/icons/arrow-link'

import { mapGetters } from 'vuex';

export default {
  name: 'comunicacion-el',
  props: ['data'],
  components: {
    'arrow-link': arrowLink
  },
  computed: {
    ...mapGetters({
      colors: 'basicColors',
      style: 'getStyles'
    }),
    ownstyle: function () {
      return {
        comunicacion: {
          'border-bottom': `1px solid ${this.colors.medium_black}`
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/home/comunicacion-el.vue